import {
  Button,
  ButtonColors,
  ButtonSizes,
  ButtonVariants,
} from '../../Button';

type Props = {
  disabled?: boolean;
  onClick: VoidFunction;
};

export default function RevertChangesButton({ disabled, onClick }: Props) {
  function handleClick() {
    onClick();
  }

  return (
    <Button
      variant={ButtonVariants.TEXT}
      color={ButtonColors.PURPLE}
      size={ButtonSizes.S}
      onClick={handleClick}
      iconNameLeft={'refreshCcw'}
      label='Revert to current published version'
      disabled={disabled}
    />
  );
}
